import React from "react";
import "./About.css";
import Image from "../../assets/avatar-2.svg";
import Resume from "../../assets/Jitendra_Parmar_Resume.pdf";
import AboutBox from "./AboutBox";

const About = () => {
  const downloadResume = async () => {
    window.open(Resume, "_blank");
  };

  return (
      <section className="about container section" id="about">
          <h2 className="section__title">About Me </h2>

          <div className="about__container grid">
              <img src={Image} alt="" className="about__img" />

              <div className="about__data grid">
                  <div className="about__info">
                      <p className="about__description">
                          Frontend Developer with 9+ years of experience
                          building scalable SaaS platforms using React.js,
                          Next.js, TypeScript, and modern frontend technologies.
                          Proven track record of improving Core Web Vitals by
                          60%, reducing UI development time by 40%, and
                          delivering high-performance web applications serving
                          10,000+ active users. Experienced in performance
                          optimization, reusable component architecture, REST
                          API integration, and responsive user-centric design.
                      </p>
                      {/* <ul className="about__list">
              <li>JavaScript (ES6+)</li>
              <li>TypeScript</li>
              <li>React</li>
              <li>Node.js</li>
              <li>Postgres SQL</li>
              <li>NestJS</li>
            </ul> */}
                      <button className="btn" onClick={downloadResume}>
                          Donwload CV
                      </button>
                  </div>

                  <div className="about__skills grid">
                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">HTML 5 and CSS</h3>
                              <span className="skills__number">90%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage development"></span>
                          </div>
                      </div>

                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">JavaScript</h3>
                              <span className="skills__number">70%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage ui__design"></span>
                          </div>
                      </div>

                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">
                                  Responsive Web Design
                              </h3>
                              <span className="skills__number">80%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage photography"></span>
                          </div>
                      </div>

                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">React</h3>
                              <span className="skills__number">70%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage react"></span>
                          </div>
                      </div>

                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">Photoshop</h3>
                              <span className="skills__number">60%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage photoshop"></span>
                          </div>
                      </div>

                      <div className="skills__data">
                          <div className="skills__titles">
                              <h3 className="skills__name">Illustrator</h3>
                              <span className="skills__number">60%</span>
                          </div>

                          <div className="skills__bar">
                              <span className="skills__percentage illustrator"></span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <AboutBox />
      </section>
  );
};

export default About;
